import { render, staticRenderFns } from "./LegalCasesModal.vue?vue&type=template&id=3fd03a02&scoped=true"
import script from "./LegalCasesModal.vue?vue&type=script&lang=js"
export * from "./LegalCasesModal.vue?vue&type=script&lang=js"
import style0 from "./LegalCasesModal.vue?vue&type=style&index=0&id=3fd03a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd03a02",
  null
  
)

export default component.exports